import { FC } from 'react';

import * as Colors from '../../theme/colors';

type LowProps = {
  width?: string;
  color?: string;
};

export const Low: FC<LowProps> = ({ width, color }) => (
  <svg
    role="img"
    width={width ?? '24'}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 18.1132L3.80425 5H20.1958L12 18.1132Z"
      stroke={color ?? Colors.low.primary}
      strokeWidth="2"
    />
  </svg>
);
